import { WARRANTY_STATUS_LABELS, type WarrantyStatus } from "@shared/modules/x-garanties";
import { Badge } from "../../../core/components/ui/badge";
import { STATUS_VARIANT } from "../lib/status";

export function WarrantyStatusBadge({ status }: { status: WarrantyStatus }) {
  return <Badge variant={STATUS_VARIANT[status]}>{WARRANTY_STATUS_LABELS[status]}</Badge>;
}
